import axios from '@/libs/axios'

let cookieCleanerInterval = null

export default {
  setToken(state, payload) {
    payload.forEach(element => {
      state.authentication[element.type] = element.value
      
      if (element.type === 'token') {
        const token = element.value

        const expireTime = Date.now() + 60 * 60 * 1000
        localStorage.setItem('coin', token)
        localStorage.setItem('token_expire', expireTime)
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

        if (!cookieCleanerInterval) {
          cookieCleanerInterval = setInterval(() => {
            const token = localStorage.getItem('coin')
            const expire = Number(localStorage.getItem('token_expire'))

            if (!token || Date.now() > expire) {
              console.log('[Auth] Token expired. Logging out...')

              const cookies = document.cookie.split(";")
              const expireDate = new Date(0).toUTCString()
              for (const cookie of cookies) {
                const eqPos = cookie.indexOf("=")
                const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()
                document.cookie = `${name}=;expires=${expireDate};path=/`
              }

              localStorage.removeItem('coin')
              localStorage.removeItem('role')
              localStorage.removeItem('token')
              localStorage.removeItem('token_expire')
              delete axios.defaults.headers.common['Authorization']

              clearInterval(cookieCleanerInterval)
              cookieCleanerInterval = null

              window.location.href = '/login'
            }
          }, 1000)
        }
      }
    })
  },

  setUser(state, payload) {
    state.activeUser[payload.type] = payload.value
  },

  removeToken(state) {
    state.token = {
      type: '',
      token: '',
      refresh_token: ''
    }
    localStorage.removeItem('coin')
    localStorage.removeItem('role')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('api_token')
    localStorage.removeItem('userData')
  },

  removeCookies() {
    const cookies = document.cookie.split(";")
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf("=")
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    }
  }
}
